import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import share from '../../images/share-ios.svg.js';
import { SocialShare as SocialShare$1 } from './SocialShare.styles.js';

function SocialShare() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    canShare = _useState2[0],
    setCanShare = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    title = _useState4[0],
    setTitle = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    url = _useState6[0],
    setUrl = _useState6[1];
  useEffect(function () {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      var _document, _window;
      var supportsShare = typeof navigator.share === 'function';
      var docTitle = ((_document = document) === null || _document === void 0 ? void 0 : _document.title) || '';
      var currentUrl = ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href) || '';
      setCanShare(supportsShare && !!docTitle && !!currentUrl);
      setTitle(docTitle);
      setUrl(currentUrl);
    }
  }, []);
  var handleShare = function handleShare(event) {
    var _navigator;
    event.preventDefault();
    if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.share && title && url) {
      navigator.share({
        title: title,
        text: 'Check out this post:',
        url: url
      })["catch"](function (error) {
        return console.log('Error sharing:', error);
      });
    } else {
      console.log('Sharing is not supported in this browser.');
    }
  };
  if (!canShare) return null;
  return /*#__PURE__*/React__default.createElement(SocialShare$1, null, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleShare,
    className: "share",
    type: "button"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: share,
    alt: "Share this page"
  })));
}

export { SocialShare as default };
//# sourceMappingURL=index.js.map
